import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Address_Interface } from 'src/app/Interface/Address_Interface';
import { Customer_Interface } from 'src/app/Interface/Customer_Interface';
import { Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { Cutomer_Title_Interface } from 'src/app/Interface/Cutomer_Title_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { KarshnasMasol_Interface } from 'src/app/Interface/KarshnasMasol_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private http: HttpClient) { }


  GetRecord1(
    Token: String,
    Province: String,
    City: String,
    Name: String,
    Code: String,
    Karshenas: String,
    SearchCommentType: Number,
    SubmitPeriodDate: number,
    HasCertificateAddress: number,
    FeildActivity: String,
    StartSearchDate: String,
    EndSearchDate: String,
    JustActive: boolean,
  ): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Cutomer?token=" + Token
      + "&Province=" + Province
      + "&City=" + City
      + "&Name=" + Name
      + "&Code=" + Code
      + "&Karshenas=" + Karshenas
      + "&SearchCommentType=" + SearchCommentType
      + "&FeildActivity=" + FeildActivity
      + "&StartSearchDate=" + StartSearchDate
      + "&EndSearchDate=" + EndSearchDate
      + "&SubmitPeriodDate=" + SubmitPeriodDate
      + "&HasCertificateAddress=" + HasCertificateAddress
      + "&JustActive=" + JustActive
    ).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetCustomerByComment(
    Token: String,
    Province: String,
    City: String,
    Name: String,
    FeildActivity: String,
  ): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Cutomer/GetCustomerByComment?token=" + Token
      + "&Province=" + Province
      + "&City=" + City
      + "&Name=" + Name
      + "&FeildActivity=" + FeildActivity
    ).pipe(
      map(data => {

        return data as any
      })
    )
  }

  GetSearchCalibration(Token: String, keySearch: String): Observable<Array<Customer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Cutomer/GetSearchCalibration?token=" + Token
      + "&keySearch=" + keySearch).pipe(
        map(data => {
          return data as Array<Customer_List_Interface>
        })
      )
  }

  GetSearchCertificate(Token: String, keySearch: String): Observable<Array<Customer_List_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Cutomer/GetSearchCertificate?token=" + Token
      + "&keySearch=" + keySearch).pipe(
        map(data => {
          return data as Array<Customer_List_Interface>
        })
      )
  }

  GetDetailCount(Token: String): Observable<any> {
    return this.http.get(environment.BaseUrl
      + "Daro/Cutomer/GetDetailCount?token=" + Token).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetSingle(Token: String, id: Number): Observable<Customer_Interface> {
    return this.http.get(environment.BaseUrl + "Daro/Cutomer/GetSingle?token=" + Token + "&id=" + id).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )
  }

  GetSingleUser(Token: String, id: Number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Cutomer/GetSingleUser?token=" + Token + "&id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetCustomerComment(Token: String, id: Number, FromMenuCustomer: Number): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Cutomer/GetCustomerComment?token=" + Token
      + "&id=" + id
      + "&FromMenuCustomer=" + FromMenuCustomer).pipe(
        map(data => {
          return data as Array<General_Interface>
        })
      )
  }

  GetCustomerCommentCheck(Token: String): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Cutomer/GetCustomerCommentCheck?token=" + Token).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }

  AddCustomer(model: Customer_Interface,
    KarshnasMasol: Array<KarshnasMasol_Interface>,
    Address: Array<Address_Interface>,
    FeildActivity: Array<number>,
    Token: String): Observable<Customer_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var Local_KarshnasMasol: Array<any> = []
    for (let item of KarshnasMasol) {

      for (let detail of item.Dakhli) {
        item.dakhli_temp = item.dakhli_temp + "," + detail.title
      }

      for (let detail of item.Tel) {
        item.tel_temp = item.tel_temp + "," + detail.title
      }

      for (let detail of item.Email) {
        item.email_temp = item.email_temp + "," + detail.title
      }

      Local_KarshnasMasol.push({
        id: item.id,
        Semat: item.semat,
        Name: item.lname,
        fname: item.fname,
        sex: (item.sex == 1),
        email: item.email_temp,
        Dakheli: item.dakhli_temp,
        Moble: item.mobile + '',
        type: Number(item.type),
        majaziMobile: item.majaziMobile + '',
        jaygozinMiblie: item.jaygozinMiblie + '',
        Tel: item.tel_temp,
        Dsc: item.dsc,
        SmsActive: item.smsActive,

        del: false,
      })
    }

    var Local_Address: Array<any> = []
    for (let item of Address) {

      for (let detail of item.tel) {
        item.tel_temp = item.tel_temp + "," + detail.title
      }


      for (let detail of item.email) {
        item.email_temp = item.email_temp + "," + detail.title
      }


      Local_Address.push({
        id: item.id,
        title_id: Number(item.title_id),
        address: item.address,
        codepost: item.codepost,
        sandoghpost: item.sandoghpost,
        pishShomareh: item.pishShomareh,
        certificateAddress: item.certificateAddress,
        certificateAddress_en: item.certificateAddress_en,
        tel_list: item.tel_temp,
        email_list: item.email_temp,
        Dakheli: item.dakheli,
        Fax: item.fax,
        Dsc: item.dsc,
        del: false,
      })
    }

    var body = {
      Token: Token,
      model: model,
      KarshnasMasol: Local_KarshnasMasol,
      Address: Local_Address,
      FeildActivity: FeildActivity,
    }


    return this.http.post(environment.BaseUrl + "Daro/Cutomer/Add", body, { headers }).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )

  }

  AddComment(Dsc: String, CustomerId: number, Token: String): Observable<any> {
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      username: Token,
      customer_id: CustomerId,
      dsc: Dsc,
    }


    return this.http.post(environment.BaseUrl + "Daro/Cutomer/AddComment", body, { headers }).pipe(
      map(data => {
        return data as any
      })
    )

  }

  EditCustomer(model: Customer_Interface,
    KarshnasMasol: Array<KarshnasMasol_Interface>,
    Address: Array<Address_Interface>,
    FeildActivity: Array<number>,
    Token: String): Observable<Customer_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var Local_KarshnasMasol: Array<any> = []
    for (let item of KarshnasMasol) {

      for (let detail of item.Dakhli) {
        item.dakhli_temp = item.dakhli_temp + "," + detail.title
      }

      for (let detail of item.Tel) {
        item.tel_temp = item.tel_temp + "," + detail.title
      }

      for (let detail of item.Email) {
        item.email_temp = item.email_temp + "," + detail.title
      }


      Local_KarshnasMasol.push({
        id: item.id,
        Semat: item.semat,
        Name: item.lname,
        fname: item.fname,
        sex: (item.sex == 1),
        email: item.email_temp,
        Dakheli: item.dakhli_temp,
        Moble: item.mobile + '',
        type: Number(item.type),
        majaziMobile: item.majaziMobile + '',
        jaygozinMiblie: item.jaygozinMiblie + '',
        Tel: item.tel_temp,
        Dsc: item.dsc,
        SmsActive: item.smsActive,
        del: false,
      })
    }


    var Local_Address: Array<any> = []
    for (let item of Address) {


      for (let detail of item.tel) {
        item.tel_temp = item.tel_temp + "," + detail.title
      }

      for (let detail of item.email) {
        item.email_temp = item.email_temp + "," + detail.title
      }


      Local_Address.push({
        id: item.id,
        title_id: Number(item.title_id),
        address: item.address,
        codepost: item.codepost,
        sandoghpost: item.sandoghpost,
        pishShomareh: item.pishShomareh,
        certificateAddress: item.certificateAddress,
        certificateAddress_en: item.certificateAddress_en,
        tel_list: item.tel_temp,
        email_list: item.email_temp,
        Dakheli: item.dakheli,
        Fax: item.fax,
        Dsc: item.dsc,
        del: false,
      })
    }


    var body = {
      Token: Token,
      model: model,
      KarshnasMasol: Local_KarshnasMasol,
      FeildActivity: FeildActivity,
      Address: Local_Address
    }


    return this.http.post(environment.BaseUrl + "Daro/Cutomer/Edit", body, { headers }).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )

  }

  EditUserCustomer(model: Customer_Interface,
    KarshnasMasol: Array<KarshnasMasol_Interface>,
    Address: Array<Address_Interface>,
    FeildActivity: Array<number>,
    Token: String): Observable<Customer_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var Local_KarshnasMasol: Array<any> = []
    for (let item of KarshnasMasol) {

      for (let detail of item.Dakhli) {
        item.dakhli_temp = item.dakhli_temp + "," + detail.title
      }

      for (let detail of item.Tel) {
        item.tel_temp = item.tel_temp + "," + detail.title
      }

      for (let detail of item.Email) {
        item.email_temp = item.email_temp + "," + detail.title
      }


      Local_KarshnasMasol.push({
        id: item.id,
        Semat: item.semat,
        Name: item.lname,
        fname: item.fname,
        sex: (item.sex == 1),
        email: item.email_temp,
        Dakheli: item.dakhli_temp,
        Moble: item.mobile + '',
        type: Number(item.type),
        majaziMobile: item.majaziMobile + '',
        jaygozinMiblie: item.jaygozinMiblie + '',
        Tel: item.tel_temp,
        Dsc: item.dsc,
        del: false,
      })
    }

    var Local_Address: Array<any> = []
    for (let item of Address) {
      Local_Address.push({
        id: item.id,
        title_id: Number(item.title_id),
        address: item.address,
        codepost: item.codepost,
        sandoghpost: item.sandoghpost,
        pishShomareh: item.pishShomareh,
        certificateAddress: item.certificateAddress,
        Tel: item.tel,
        Dakheli: item.dakheli,
        Fax: item.fax,
        Dsc: item.dsc,
        del: false,
      })
    }

    var body = {
      Token: Token,
      model: model,
      KarshnasMasol: Local_KarshnasMasol,
      FeildActivity: FeildActivity,
      Address: Local_Address
    }


    return this.http.post(environment.BaseUrl + "Daro/Cutomer/EditUser", body, { headers }).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )

  }

  EditCalibration(model: Customer_Interface,
    KarshnasMasol: Array<KarshnasMasol_Interface>,
    Token: String): Observable<Customer_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var Local_KarshnasMasol: Array<any> = []
    for (let item of KarshnasMasol) {



      if (item.Dakhli != undefined) {
        for (let detail of item.Dakhli) {
          item.dakhli_temp = item.dakhli_temp + "," + detail.title
        }
      }

      for (let detail of item.Tel) {
        item.tel_temp = item.tel_temp + "," + detail.title
      }

      if (item.Dakhli != undefined) {
        for (let detail of item.Email) {
          item.email_temp = item.email_temp + "," + detail.title
        }
      }


      Local_KarshnasMasol.push({
        id: item.id,
        Semat: item.semat,
        Name: item.lname,
        fname: item.fname,
        sex: (item.sex == 1),
        email: item.email_temp,
        Dakheli: item.dakhli_temp,
        Moble: item.mobile + '',
        Tel: item.tel_temp,
        type: Number(item.type),
        jaygozinMiblie: item.jaygozinMiblie + '',
        majaziMobile: item.majaziMobile + '',
        Dsc: item.dsc,
        del: false,
      })
    }


    var body = {
      Token: Token,
      model: model,
      KarshnasMasol: Local_KarshnasMasol,
    }


    return this.http.post(environment.BaseUrl + "Daro/Cutomer/EditCalibration", body, { headers }).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )

  }

  EditKarshnas(model: Customer_Interface,
    KarshnasMasol: Array<KarshnasMasol_Interface>,
    Token: String): Observable<Customer_Interface> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var Local_KarshnasMasol: Array<any> = []
    for (let item of KarshnasMasol) {



      if (item.Dakhli != undefined) {
        for (let detail of item.Dakhli) {
          item.dakhli_temp = item.dakhli_temp + "," + detail.title
        }
      }

      for (let detail of item.Tel) {
        item.tel_temp = item.tel_temp + "," + detail.title
      }

      if (item.Dakhli != undefined) {
        for (let detail of item.Email) {
          item.email_temp = item.email_temp + "," + detail.title
        }
      }


      Local_KarshnasMasol.push({
        id: item.id,
        Semat: item.semat,
        Name: item.lname,
        fname: item.fname,
        sex: (item.sex == 1),
        email: item.email_temp,
        Dakheli: item.dakhli_temp,
        Moble: item.mobile + '',
        Tel: item.tel_temp,
        type: Number(item.type),
        jaygozinMiblie: item.jaygozinMiblie + '',
        majaziMobile: item.majaziMobile + '',
        Dsc: item.dsc,
        del: false,
      })
    }


    var body = {
      Token: Token,
      model: model,
      KarshnasMasol: Local_KarshnasMasol,
    }


    return this.http.post(environment.BaseUrl + "Daro/Cutomer/EditKarshnas", body, { headers }).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )

  }


  DeleteCustomer(id: number, Token: String): Observable<Customer_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Cutomer/Delete?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )

  }

  AcrchiveCustomer(id: number, Token: String): Observable<Customer_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Cutomer/Acrchive?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )

  }

  SpecialCustomer(id: number, Token: String): Observable<Customer_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Cutomer/special?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )

  }

  CommentStatus(id: number, Statuse: number, Priority: number, Token: String): Observable<Customer_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Cutomer/CommentStatus?id=" + id
      + "&token=" + Token
      + "&Priority=" + Priority
      + "&Statuse=" + Statuse).pipe(
        map(data => {
          return data as Customer_Interface
        })
      )
  }

  CommentEdit(id: number, dsc: String, Token: String): Observable<any> {

    return this.http.get(environment.BaseUrl + "Daro/Cutomer/CommentEdit?id=" + id
      + "&token=" + Token
      + "&dsc=" + dsc).pipe(
        map(data => {
          return data as any
        })
      )
  }

  GetLinkKarshnasMasole(Token: String, id: number, type: number): Observable<Array<string>> {
    return this.http.get(environment.BaseUrl + "Daro/Cutomer/GetLinkKarshnasMasole?token=" + Token
      + "&id=" + id
      + "&type=" + type).pipe(
        map(data => {
          return data as Array<string>
        })
      )
  }


  CommentDelete(id: number, Token: String): Observable<Customer_Interface> {

    return this.http.get(environment.BaseUrl + "Daro/Cutomer/CommentDelete?id=" + id + "&token=" + Token).pipe(
      map(data => {
        return data as Customer_Interface
      })
    )

  }


  GetCustomerTitle(Token: String, id: number): Observable<Array<Cutomer_Title_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Cutomer/GetCustomerTitle?token=" + Token
      + "&id=" + id).pipe(
        map(data => {
          return data as Array<Cutomer_Title_Interface>
        })
      )
  }


  GetKarshnas_Type(Token: String): Observable<Array<General_Interface>> {
    return this.http.get(environment.BaseUrl + "Daro/Cutomer/GetKarshnas_Type?token=" + Token).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )
  }

}
